import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import Vcode from 'react-vcode';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { changeLoading } from '@/redux/base.redux';
import styles from './index.module.scss';
import { api } from "@/routes/api";
import axios from '@/util/axios';
import { getQueryString } from '@/util/util';
import { Loading } from '@/components/Loading';

@withRouter
@connect(
  null,
  { changeLoading }
)
class SecurityCheck extends Component {
  constructor(props) {
    super(props);
    const { search } = props.history.location;
    this.state = {
      code: (getQueryString('code', search) || getQueryString('outerCodeId', search)) || '',
      verCode: '',
      verSuccessCode: '',
      info: {},
      loading: false,
      showModal: false
    }
  }
  componentDidMount = () => {
    // console.log(getQueryString('code',this.props.history.location.search));
    // this.setState({  })
    this.props.changeLoading(true);
    this.getVerCode();
    setTimeout(() => this.props.changeLoading(false), 500);
  }
  handleSearchVerCode = async () => {
    const { code, verCode, verSuccessCode } = this.state;
    let errMsg = '';
    if (!code) errMsg = '请输入防伪码';
    // else if (code.length !== 16 && code.length !== 20) errMsg = '请输入16位或20位防伪码';
    else if (!verCode) errMsg = '请输入验证码';
    else if (verCode !== verSuccessCode) {
      errMsg = '请输入正确的验证码';
      this.getVerCode();
    }
    if (errMsg) {
      toast.error(`❌ ${errMsg}`);
      return;
    }
    this.setState({ loading: true });
    const res = await axios.post(api.checkAntiFake, { code });
    if (res.code === 0) {
      const info = res.data[0];
      this.setState({ info, loading: false, showModal: true });
    } else {
      this.setState({ loading: false });
    }
    this.getVerCode();
  }
  handleChange = (key, value) => this.setState({ [key]: value });
  getVerCode = () => this.setState({ verSuccessCode: Math.ceil(Math.random() * 10000).toString() });
  onKeyup = (e) => {
    if (e.keyCode === 13) {
      this.handleSearchVerCode();
    }
  }

  //解决iOS字体小于16px自动缩放问题
  handleInputMouseDown = e => {
    e.target.style.fontSize = '16px';
  }
  handleInputFocus = e => {
    e.target.style.fontSize = '';
  }

  render() {
    const { code, verCode, verSuccessCode, info, loading, showModal } = this.state;
    return (
      <div>
        <div className={`${styles.banner} ${styles.top_banner}`}>
          <img
            className={styles.banner_img}
            src="/images/top_banner.jpg"
            alt="banner"
          />
        </div>
        <div className={styles.search_container}>
          <div className={styles.left_container}>
            <img src="/images/productInfo/product_info_1.png" alt="" />
          </div>
          <div className={styles.center_wrapper}>
            <div className={styles.app_title}>防伪查询</div>
            <div className={styles.center_container}>
              <div className={styles.rows}>
                <span className={styles.label}>防伪码：</span>
                <input
                  value={code}
                  className={styles.input}
                  placeholder="请输入16位或20位防伪码"
                  onChange={(e) => this.handleChange("code", e.target.value)}
                  onKeyUp={this.onKeyup}
                  onMouseDown={this.handleInputMouseDown}
                  onFocus={this.handleInputFocus}
                />
              </div>
              <div className={styles.rows}>
                <span className={styles.label}>验证码：</span>
                <input
                  className={`${styles.input} ${styles.verCodeInput}`}
                  placeholder="请输入验证码"
                  onChange={(e) => this.handleChange("verCode", e.target.value)}
                  value={verCode}
                  onKeyUp={this.onKeyup}
                  onMouseDown={this.handleInputMouseDown}
                  onFocus={this.handleInputFocus}
                />
                <Vcode
                  className={styles.verCode}
                  value={verSuccessCode}
                  width={110}
                  height={30}
                  length={4}
                  onClick={this.getVerCode}
                />
              </div>
              <div className={styles.btns}>
                <div className={styles.clickSeach} onClick={this.handleSearchVerCode}>点 击 查 询</div>
              </div>
              {info.flickCount && showModal ? (
                <Fragment>
                  {/* <span className={styles.result_tips}>{parseInt(info.flickCount) === 1 ? info.productDetail.prompt : info.prompt}</span> */}
                  <span className={styles.result_tips}>{info.prompt}</span>
                  <div className={styles.result}>
                    <div className={styles.row}>
                      <span className={styles.count}>当前为第{info.flickCount}次查询，为正品的身份码</span>
                    </div>
                    <div className={styles.row}>
                      <span className={styles.result_label}>产品唯一身份编码</span>
                      <span className={styles.text}>{info.productDetail.fakeCode}</span>
                    </div>
                    <div className={styles.row}>
                      <span className={styles.result_label}>首次查询时间</span>
                      <span className={styles.text}>{info.firstFlickTime}</span>
                    </div>
                    <div className={styles.row}>
                      <span className={styles.result_label}>企业名称</span>
                      <span className={styles.text}>{info.productDetail.businessName}</span>
                    </div>
                    {/* <div className={styles.row}>
                      <span className={styles.result_label}>品牌名称</span>
                      <span className={styles.text}>{info.productDetail.brand}</span>
                    </div> */}
                    <div className={styles.row}>
                      <span className={styles.result_label}>产品身份标识对比</span>
                      <span className={styles.text}>
                        <img src={info.fakeUrl} alt="" style={{ width: 140 }} />
                      </span>
                    </div>
                    <div className={styles.row}>
                      <span className={styles.tips}>查询小贴士：产品所贴防伪标识应与查询结果标识图案基本一致，数字编码以产品标识为准</span>
                    </div>
                  </div>
                </Fragment>
              ) : null}
              {loading && <Loading />}
            </div>
          </div>
          <div className={styles.right_container}>
            <img src="/images/productInfo/product_info_2.png" alt="" />
          </div>
          <div className={styles.clearfix}></div>
          <div className={styles.app_footer}>
          <div className={styles.app_img_container}>
            <img src="/images/logo.png" alt=""/>
          </div>
          <div className={styles.app_info_container}>
            <div className={styles.app_info}>
              <div>杭州雅集茶具有限公司</div>
              <a href="http://beian.miit.gov.cn" target="_black" style={{ color: 'rgba(0, 0, 0, .65)' }}>浙ICP备11028005号-2</a>
            </div>
            <div className={styles.app_info}>
              <div>雅集专线:0571-86551555</div>
              <div>浙公网安备 33010802004971号</div>
            </div>
          </div>
        </div>
        </div>
      </div>
    );
  }
}

export default SecurityCheck;
